<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Remitter Credits</h2>
          </div>
          <div class="body pt-0">
            <div class="chart-top-action d-lg-flex justify-content-end py-3">
              <div class="fliter-main mr-auto mt-3 mt-md-0">
                <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button>
              </div>
              <!-- Toggle Filter Collapse -->
              <b-collapse
                id="fliter-collapse"
                class="fliter-collapse"
                v-model="isVisibleFilter"
              >
                <div
                  class="d-flex flex-column justify-content-between pt-3 pr-3 pl-3 middleware-list-wrapper"
                >
                  <div
                    v-for="(item, index) in advanceFilters"
                    :key="index"
                    class="d-flex middleware-list"
                  >
                    <div
                      class="form-group form-select single-multiselect m-0 column-1"
                    >
                      <span class="float-label w-100">
                        <label>Select Field</label>
                        <multiselect
                          placeholder=""
                          v-model="item.field"
                          :show-labels="false"
                          :options="filterField"
                          label="name"
                          :searchable="true"
                          :allowEmpty="false"
                          @select="fieldsUpdate"
                        ></multiselect>
                      </span>
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group m-0 column-2"
                      v-if="item.field && item.field.id == 'customer'"
                    >
                      <input
                        class="form-control"
                        type="text"
                        v-model="item.search"
                        placeholder="Enter Payangel Id"
                      />
                      <div class="line"></div>
                    </div>
                    <div
                      class="form-group form-select m-0 single-multiselect column-2"
                      v-if="item.field && item.field.id == 'credit_type'"
                    >
                      <span class="float-label w-100">
                        <label>Select Credit Type</label>
                        <multiselect
                          placeholder=""
                          v-model="item.search"
                          :show-labels="false"
                          :options="creditType_Options"
                          :searchable="true"
                        ></multiselect>
                      </span>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'amount'"
                    >
                      <div
                        class="form-group form-select m-0 single-multiselect column-2-half"
                      >
                        <span class="float-label">
                          <label for="transaction">Select</label>
                          <multiselect
                            placeholder=""
                            v-model="item.amount.type"
                            :show-labels="false"
                            :options="amountOptions"
                            :searchable="true"
                            label="name"
                            track-by="id"
                            @select="amountFieldUpdate"
                          ></multiselect>
                        </span>
                        <div class="line"></div>
                      </div>
                      <div class="form-group m-0 column-2-half">
                        <input
                          class="form-control"
                          type="text"
                          v-model="item.amount.value"
                          :placeholder="'Enter ' + item.field.name"
                          @keypress="onlyNumber($event)"
                        />
                        <div class="line"></div>
                      </div>
                    </div>
                    <div
                      class="column-2"
                      v-if="item.field && item.field.id == 'date'"
                    >
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">From</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.from"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                      <div class="form-group datepicker m-0 column-2-half">
                        <b-input-group class="flex-nowrap">
                          <div class="input-group-prepend">
                            <span class="input-group-text">To</span>
                            <span
                              class="input-group-text"
                              @click="$refs.birthdate1.showCalendar()"
                            >
                              <i class="icon-calendar"></i>
                            </span>
                          </div>
                          <datepicker
                            class="form-control"
                            ref="birthdate1"
                            v-model="item.date.to"
                            :bootstrap-styling="false"
                            placeholder=""
                            :typeable="true"
                          ></datepicker>
                        </b-input-group>
                      </div>
                    </div>
                    <div v-if="advanceFilters.length > 1" class="column-3">
                      <b-button
                        class="fliter-btn btn-lg"
                        variant="outline-danger"
                        @click="removeFilter(index)"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </b-button>
                    </div>
                  </div>
                  <div class="text-left">
                    <b-button
                      class="fliter-btn w-auto"
                      variant="outline-primary"
                      @click="appendFilter"
                    >
                      <i class="fa fa-plus" aria-hidden="true"></i>
                      Add more filters
                    </b-button>
                  </div>
                </div>
                <div class="pb-3 pr-3 text-right">
                  <button
                    class="btn btn-primary w-auto"
                    @click="applyTestfilter"
                  >
                    Apply
                  </button>
                  <button
                    class="btn btn-outline-danger w-auto ml-3"
                    @click="clearTestfilter"
                  >
                    Cancel & Close
                  </button>
                </div>
              </b-collapse>
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <router-link
                    class="btn btn-primary btn-mw btn-lg"
                    to="/remitter-credit/create"
                  >
                    Add New
                    <i class="fa fa-plus-square"></i>
                  </router-link>
                </div>
                <b-dropdown
                  class="ml-2"
                  id="download"
                  text="Download"
                  size="lg"
                  variant="outline-primary btn-mw"
                >
                  <template #button-content>
                    Download Report
                    <i class="fa fa-download"></i>
                  </template>
                  <b-dropdown-item href="">Export as PDF</b-dropdown-item>
                  <b-dropdown-item href="">Export as CSV</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <!-- displayed Filters -->
            <div
              class="filter-list-area d-flex flex-wrap align-items-center mb-1"
              v-if="displayFilters && displayFilters.length > 0"
            >
              <i
                class="fa fa-filter text-primary mr-1 mb-2"
                aria-hidden="true"
              ></i>
              <div
                class="mb-1"
                v-for="(item, index) in displayFilters"
                :key="index"
              >
                <label
                  class="font-14 line-height-18 mb-0 ml-2"
                  v-if="
                    index == 0 ||
                    item.filter_field != displayFilters[index - 1].filter_field
                  "
                >
                  {{ item.field_name + ":" }}
                </label>
                <!-- Only for Date -->
                <template v-if="item.filter_field == 'date'">
                  <span
                    class="badge badge-warning-solid mr-1"
                    v-for="(date, indexValue) in item.filter_value"
                    :key="indexValue"
                  >
                    <span v-if="date">
                      {{ indexValue + ": " + date }}
                      <i
                        class="fa fa-close cursor-pointer ml-1"
                        @click="removeDate(indexValue, index)"
                      ></i>
                    </span>
                  </span>
                </template>
                <!-- Other filter -->
                <span class="badge badge-warning-solid" v-else>
                  {{ item.filter_value ? item.filter_value : "-" }}
                  <i
                    class="fa fa-close cursor-pointer ml-1"
                    @click="removeFilter(index)"
                  ></i>
                </span>
              </div>
              <span class="text-danger cursor-pointer" @click="clearTestfilter">
                Clear all
              </span>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              ref="partnertable"
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(name)="data">
                <span>
                  <a
                    href="javascript:void(0);"
                    class="font-color"
                    @click="customerDetailModel(data.item)"
                    v-if="data.value"
                  >
                    {{ data.value }}
                    <span v-if="data.index == 0" class="badge badge-danger">
                      voided
                    </span>
                  </a>
                </span>
              </template>
              <template #cell(action)="row">
                <b-dropdown
                  id="dropdown-1"
                  text="Actions"
                  size="sm"
                  right
                  variant="outline-primary"
                >
                  <b-dropdown-item @click="edit(row.item)">
                    Edit
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditRemitterCreditModel :remitterCredit="remitterCredit" />
    <CustomerDetailsModel :customerDetail="customerDetail" />
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import { GET_CUSTOMER_DETAILS } from "../../../store/actions.type.js";
import CustomerDetailsModel from "../../core/CustomerDetailsModel.vue";
import EditRemitterCreditModel from "../../core/EditRemitterCreditModel.vue";
import { mapState, mapGetters } from "vuex";
const moment = require("moment");
export default {
  name: "RemitterCreditComponent",
  components: {
    BreadCrumb,
    "main-loader": LoaderComponent,
    Multiselect: () => import("vue-multiselect"),
    Datepicker: () => import("vuejs-datepicker"),
    CustomerDetailsModel,
    EditRemitterCreditModel,
  },
  data() {
    return {
      customerDetail: null,
      items: [
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Hal Chalamet",
          email: "halC12@gmail.com",
          credit_type: "Credit",
          createdby: "Alizee Thomas",
          amountsent: 15.0,
          date: "2019-07-09 15:04:00",
          comment: "",
        },
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Ben Murphy",
          email: "benPM99@gmail.com",
          credit_type: "Promotional Credit",
          createdby: "John Carter",
          amountsent: 3847.0,
          date: "2019-07-09 15:04:00",
          comment: "test ",
        },
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Emma Thomas",
          email: "emthomas@mail.com",
          credit_type: "Goodwill Gesture",
          createdby: "Alizee Thomas",
          amountsent: 450.0,
          date: "2019-07-09 15:04:00",
          comment: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        },
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Adam Driver",
          email: "AdamD@yopmail.com",
          credit_type: "Referral Credit",
          createdby: "Ragnar Lothbrok",
          amountsent: 18.0,
          date: "2019-07-09 15:04:00",
          comment: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        },
        {
          id: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
          name: "Brain O'Conner",
          email: "connerBrain@mailinator.com",
          credit_type: "Refund",
          createdby: "Benjamin Walker",
          amountsent: 573.0,
          date: "2019-07-09 15:04:00",
          comment: "5b3e6e75-364c-4bd9-b36c-d74188afc750",
        },
      ],
      fields: [
        {
          key: "credit_type",
          label: "Credit Type",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "name",
          label: "Sent to Customer",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "amountsent",
          label: "Amount Sent",
          sortable: true,
          thClass: "th_sortfix",
        },
        { key: "date", label: "Date", sortable: true, thClass: "th_sortfix" },
        {
          key: "createdby",
          label: "Created by",
          sortable: true,
          thClass: "th_sortfix",
        },
        {
          key: "action",
          label: "Action",
          thClass: "th_sortfix text-right pr-4",
          tdClass: "text-right",
        },
      ],
      remitterCredit: {
        customer: "",
        comment: "",
        amount: "",
        creditType: "",
      },
      creditType_Options: [
        "Promotional Credit",
        "Goodwill Gesture",
        "Refund",
        "Referral Credit",
        "Credit",
      ],
      isVisibleFilter: false,
      displayFilters: [],
      filterField: [
        { id: "credit_type", name: "Credit Type", $isDisabled: false },
        { id: "customer", name: "Customer", $isDisabled: false },
        { id: "date", name: "Date", $isDisabled: false },
        { id: "amount", name: "Amount", $isDisabled: false },
      ],
      amountOptions: [
        { id: "greaterthan", name: "Greater Than", $isDisabled: false },
        { id: "lessthan", name: "Less Than", $isDisabled: false },
        { id: "equals", name: "Equals", $isDisabled: false },
      ],
      advanceFilters: [
        {
          field: { id: "credit_type", name: "Credit Type", $isDisabled: false },
          search: "",
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
        },
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filterValue: "",
      condition: "",
    };
  },
  methods: {
    edit(item) {
      ((this.remitterCredit = {
        customer: item.name,
        comment: item.comment,
        amount: item.amountsent,
        creditType: item.credit_type,
      }),
        this.$bvModal.show("edit-Remitter-credit"));
    },
    // customerDetail
    customerDetailModel(item) {
      this.$store.dispatch(GET_CUSTOMER_DETAILS, item.id).then((response) => {
        if (response.status == 200) {
          const customerdetails = response.data;
          this.$bvModal.show("customer-details");
          this.customerDetail = customerdetails;
        }
      });
    },
    opencustomerModel() {
      this.$bvModal.show("customer-list");
    },
    // for openFilters
    openFilters() {
      if (this.advanceFilters.length == 0) {
        this.advanceFilters = [
          {
            field: {
              id: "credit_type",
              name: "Credit Type",
              $isDisabled: false,
            },
            search: "",
            amount: {
              type: "",
              value: "",
            },
            date: {
              from: "",
              to: "",
            },
          },
        ];
      }
      this.isVisibleFilter = !this.isVisibleFilter;
    },
    // to append another Filter
    appendFilter() {
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
      });
      if (this.filterField.filter((data) => data.$isDisabled == false)[0]) {
        this.advanceFilters.push({
          field: this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0],
          search: "",
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
        });
        if (
          this.filterField.filter((data) => data.$isDisabled == false)[0].id !=
          "amount"
        ) {
          this.filterField.filter(
            (data) => data.$isDisabled == false,
          )[0].$isDisabled = true;
        }
      }
    },
    // update fields of filters
    fieldsUpdate() {
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (
          item.field.id != "amount" ||
          this.advanceFilters.filter((data) => data.field.id == "amount")
            .length > 2
        ) {
          this.filterField.filter(
            (data) => data.id == item.field.id,
          )[0].$isDisabled = true;
        }
        if (item.field.id != "amount") {
          item.amount.type = "";
          item.amount.value = "";
        }
      });
      this.amountFieldUpdate();
    },
    // to remove filters
    removeFilter(index) {
      if (this.advanceFilters[index].field.id == "amount") {
        this.amountOptions.filter(
          (data) => data.id == this.advanceFilters[index].amount.type.id,
        )[0].$isDisabled = false;
      }
      this.filterField.filter(
        (data) => data.id == this.advanceFilters[index].field.id,
      )[0].$isDisabled = false;
      this.advanceFilters.splice(index, 1);
      this.displayFilters.splice(index, 1);
      this.$cookies.set("remitter-credit-filter", this.displayFilters);
    },
    // remove date filters
    removeDate(indexValue, filterindex) {
      this.displayFilters[filterindex].filter_value[indexValue] = "";
      this.advanceFilters[filterindex].date[indexValue] = "";

      let temp = this.displayFilters[filterindex].filter_value;
      if (temp.from == "" && temp.to == "") {
        this.advanceFilters.splice(filterindex, 1);
        this.filterField.filter((data) => data.id == "date")[0].$isDisabled =
          false;
        this.displayFilters.splice(filterindex, 1);
      }
      this.$cookies.set("remitter-credit-filter", this.displayFilters);
    },

    // amount filter fields update
    amountFieldUpdate() {
      this.amountOptions.map((item) => {
        item.$isDisabled = false;
      });
      this.advanceFilters.map((item) => {
        if (item.amount.type) {
          this.amountOptions.filter(
            (data) => data.id == item.amount.type.id,
          )[0].$isDisabled = true;
        }
      });
    },

    // apply filters
    applyTestfilter() {
      let params = [];
      this.advanceFilters.map((item) => {
        let data = {
          filter_field: item.field.id,
          field_name: item.field.name,
        };
        if (item.field.id == "customer") {
          data.filter_value = item.search;
        }
        if (item.field.id == "credit_type") {
          data.filter_value = item.search;
        }
        if (item.field.id == "date") {
          data.filter_value = {
            from: item.date.from
              ? moment(item.date.from).format("DD-MM-YYYY")
              : "",
            to: item.date.to ? moment(item.date.to).format("DD-MM-YYYY") : "",
          };
        }
        if (item.field.id == "amount") {
          if (item.amount.type && item.amount.value) {
            data.filter_value =
              item.amount.type.name + ": " + item.amount.value;
          }
        }
        params.push(data);
      });
      this.isVisibleFilter = false;
      this.$cookies.set("remitter-credit-filter", params);
      this.displayFilters = this.$cookies.get("remitter-credit-filter");
      console.log("params", params);
    },
    // clear all filters
    clearTestfilter() {
      this.advanceFilters = [
        {
          field: { id: "credit_type", name: "Credit Type", $isDisabled: false },
          search: "",
          amount: {
            type: "",
            value: "",
          },
          date: {
            from: "",
            to: "",
          },
        },
      ];
      this.filterField.map((item) => {
        item.$isDisabled = false;
      });
      this.displayFilters = [];
      this.isVisibleFilter = false;
      this.$cookies.set("remitter-credit-filter", this.displayFilters);
    },
    cookieFilters() {
      this.displayFilters =
        this.$cookies.get("remitter-credit-filter") != null
          ? this.$cookies.get("remitter-credit-filter")
          : [];
      let filters = [];
      if (this.displayFilters && this.displayFilters.length > 0) {
        this.displayFilters.map((item) => {
          this.filterField.filter(
            (data) => data.id == item.filter_field,
          )[0].$isDisabled = true;
          if (item.filter_field == "customer") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: item.filter_value,
              amount: {
                type: "",
                value: "",
              },
              date: {
                from: "",
                to: "",
              },
            });
          }
          if (item.filter_field == "credit_type") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: this.creditType_Options.filter(
                (data) => data == item.filter_value,
              )[0],
              amount: {
                type: "",
                value: "",
              },
              date: {
                from: "",
                to: "",
              },
            });
          }
          if (item.filter_field == "amount") {
            this.amountOptions.filter(
              (data) => data.name == item.filter_value.split(":")[0],
            )[0].$isDisabled = true;
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: "",
              amount: {
                type: this.amountOptions.filter(
                  (data) => data.name == item.filter_value.split(":")[0],
                )[0],
                value: item.filter_value.split(":")[1],
              },
              date: {
                from: "",
                to: "",
              },
            });
          }
          if (item.filter_field == "date") {
            filters.push({
              field: {
                id: item.filter_field,
                name: this.filterField.filter(
                  (data) => data.id == item.filter_field,
                )[0].name,
                $isDisabled: true,
              },
              search: "",
              date: {
                from: item.filter_value.from,
                to: item.filter_value.to,
              },
              amount: {
                type: "",
                value: "",
              },
            });
          }
        });
        this.advanceFilters = filters;
      }
    },
    onlyNumber(event) {
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
      if (/^\W$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
  async mounted() {
    this.totalRows = this.items.length;
    await this.cookieFilters();
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
